import { Text, Link } from '@g2u/ui-kit';
import { encryptAesToken } from 'helpers/crypto';

import env from 'env';

type CoreBmsJobLinkProps = {
  jobId: string;
};

export const CoreBmsJobLink = ({ jobId }: CoreBmsJobLinkProps) => {
  if (!jobId) {
    return null;
  }
  return (
    <Text.$>
      <Link.$
        underline
        href={`${env.LEGACY_BMS_URL}jobs/index/edit/id/${encryptAesToken(jobId)}/tab_id/76`}
        target="_blank"
      >
        Go to Tickets tab in Core BMS
      </Link.$>
    </Text.$>
  );
};
